import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';

function collaborationMobileSlider() {

    var screencheck = function (mediasize) {
        if (typeof window.matchMedia !== "undefined") {
            var screensize = window.matchMedia("(max-width:" + mediasize + "px)");
            if (screensize.matches) {
                return true;
            } else {
                return false;
            }
        } else { // for IE9 and lower browser
            if ($winW() <= mediasize) {
                return true;
            } else {
                return false;
            }
        }
    };
    var productGallerySlider;
    $(window).on('resize', function () {
        if (screencheck(767)) {
            if (productGallerySlider) return;
            else productGallerySlider = new Swiper('.collaboration-slider', {
                modules: [Pagination],
                slidesPerView: 1,
                spaceBetween: 0,
                simulateTouch: false,
                draggable: true,
                watchSlidesVisibility: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 5
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 5
                    },
                    // when window width is >= 640px
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 5
                    }
                }
            });
        } else {
            if (productGallerySlider) {
                productGallerySlider.destroy();
                productGallerySlider = undefined;
            }
        }
    }).resize();


}

export default collaborationMobileSlider;


